export const DATA_HOOKS = {
  searchInput: 'search-input',
};
